import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchDischargeSummary, fetchMrdSummary, generateMrdEntry } from './mrd.api';
import type { MrdGeneratePayload } from './types';

export const mrdKeys = {
  all: ['mrd'] as const,
  summary: (date: string) => [...mrdKeys.all, 'summary', date] as const,
  dischargeSummary: () => [...mrdKeys.all, 'discharge-summary'] as const,
};

export const useMrdSummary = (date: string) => useQuery({
  queryKey: mrdKeys.summary(date),
  queryFn: () => fetchMrdSummary(date),
});

export const useDischargeSummary = () => useQuery({
  queryKey: mrdKeys.dischargeSummary(),
  queryFn: () => fetchDischargeSummary(),
});

export const useGenerateMrdEntry = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: MrdGeneratePayload) => generateMrdEntry(payload),
    onSuccess: async (_data, payload) => queryClient.invalidateQueries({ queryKey: mrdKeys.summary(payload.date) }),
  });
};
